import {autoRegister, resolve} from "../../container";
import {promiseFromJsonResponse, promiseFromVoidResponse} from "../../common/utils/promises";
import {RequestSugarFactory} from "../common/requestSugar";
import {SecuredRequestExecutor} from "../../module/awswaf/securedRequestExecutor";

export type ChatResponse = {
    message: string;
    chatId?: string;
    responseType: string;
    assistantMessageId?: string;
}

@autoRegister()
export class GptChatService {

    private basePath: string = "/enbw-eop/eop-app-gpt-chat/rest/stable/career-gpt";

    public constructor(private securedRequestExecutor: SecuredRequestExecutor = resolve(SecuredRequestExecutor)) {
    }

    public async postMessage(configId: string, userMessage: string, lang: string, chatId?: string): Promise<ChatResponse> {
        let path = `${this.basePath}/${configId}/${lang}`;
        if (chatId) {
            path += `?chatId=${encodeURIComponent(chatId)}`;
        }
        const postRequest = (): Promise<Response> => fetch(path, {
            method: "POST",
            headers: {
                "Content-Type": "application/json;charset=UTF-8",
                "EOP-Sugar": RequestSugarFactory.produce()
            },
            body: JSON.stringify({message: userMessage})
        });
        const response = await this.securedRequestExecutor.execute(postRequest);
        return promiseFromJsonResponse(response);
    }

    public async rateAssistantResponse(chatId: string, messageId: string, ratingPositive: boolean): Promise<void> {
        const rateRequest = (): Promise<Response> => fetch(
            `${this.basePath}/chats/${chatId}/messages/${messageId}/rating`,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json;charset=UTF-8",
                    "EOP-Sugar": RequestSugarFactory.produce()
                },
                body: JSON.stringify({positive: ratingPositive})
            }
        );
        const response = await this.securedRequestExecutor.execute(rateRequest);
        return promiseFromVoidResponse(response);
    }
}